import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

interface LandingPageProps {
  onGetStarted: () => void;
  onHaveAccount: () => void;
}

const Logo: React.FC = () => {
  return (
    <div className="flex items-center space-x-3">
      <div className="flex-shrink-0" style={{ width: '48px', height: '48px' }}>
        <img
          src="/materials/ZKOUSKA-DARK-01.png"
          alt="Dostaň se na práva"
          className="object-contain w-full h-full"
        />
      </div>
      <span
        className="font-black text-2xl text-[#ffaa00] whitespace-pre font-poppins tracking-wide italic"
        style={{ fontWeight: 900 }}
      >
        Dostaň se na práva!
      </span>
    </div>
  );
};

export const LandingPage: React.FC<LandingPageProps> = ({ onGetStarted, onHaveAccount }) => {
  return (
    <div className="min-h-screen w-full bg-white flex flex-col">
      {/* Header */}
      <header className="w-full p-6">
        <Logo />
      </header>

      {/* Main Content */}
      <main className="flex-1 flex flex-col lg:flex-row items-center justify-center px-6 lg:px-16 py-4 lg:py-8 gap-4 lg:gap-16">
        {/* Left Side - Animation */}
        <div className="flex-1 flex items-center justify-center max-w-[220px] sm:max-w-xs lg:max-w-lg">
          <div className="w-full aspect-square">
            <DotLottieReact
              src="/materials/Book.lottie"
              autoplay
              loop
              style={{ width: '100%', height: '100%' }}
            />
          </div>
        </div>

        {/* Right Side - Content */}
        <div className="flex-1 flex flex-col items-center lg:items-start text-center lg:text-left max-w-md">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 sm:mb-8 leading-tight">
            Efektivní a zábavná cesta k právní zkoušce!
          </h1>

          {/* Buttons */}
          <div className="w-full space-y-3 max-w-sm">
            {/* Primary Button - ZAČNĚTE (Green, does nothing for now) */}
            <button
              onClick={onGetStarted}
              className="w-full bg-[#ffaa00] hover:bg-[#ffaa00]/90 text-white font-bold uppercase tracking-wide text-lg rounded-xl px-8 py-4 shadow-[0_4px_0_#cc8800] active:shadow-none active:translate-y-[4px] transition-all duration-150"
            >
              Začněte
            </button>

            {/* Secondary Button - MÁM UŽ ÚČET (Opens login) */}
            <button
              onClick={onHaveAccount}
              className="w-full bg-white hover:bg-gray-50 text-[#ffaa00] font-bold uppercase tracking-wide text-lg rounded-xl px-8 py-4 border-2 border-gray-200 shadow-[0_4px_0_#e5e7eb] active:shadow-none active:translate-y-[4px] transition-all duration-150"
            >
              Mám už účet
            </button>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="w-full py-6 px-6 text-center">
        <div className="flex justify-center space-x-4 text-sm text-gray-400">
          <button className="hover:text-gray-600 transition-colors">
            Podmínky použití
          </button>
          <span>•</span>
          <button className="hover:text-gray-600 transition-colors">
            Ochrana soukromí
          </button>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
